<style>
@import '@/assets/main.css';
</style>

<template>
  <Main :tenantName="tenantName"> </Main>
</template>

<script>
import Main from "@/components/main.vue";

export default {
  name: "App",
  components: {
    Main
  },
  props: {
    tenantName: String,
  }
}
</script>
